module.exports = __webpack_public_path__ + "img/center.aefc86c4.png";